import { render, staticRenderFns } from "./sorttask.vue?vue&type=template&id=54d92416"
import script from "./sorttask.vue?vue&type=script&lang=tsx"
export * from "./sorttask.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports